define(
    'utils/fit-screen-vertically',['jquery'],
    function ($) {
        /**
         * Makes container to fit the screen.
         * Adds vertical scroll if needed.
         * Listens to sroll and resize.
         */
        
        var FitScreenVertically = (function () {

            /**
             * Contains static properties and methods.
             */
            var self = {
                //Contains all instances of obj "FitScreenVertically" that were enabled.
                enabledInstances: [],

                // reserved bottom margin if container is higher the window and height of container need to be set
                windowBottomMargin: 10,

                // minimum container height
                minHeight: 50,

                //cache window.scrollTop and window height
                window: $(window),
                scrollTop: 0,
                windowHeight: 0,

                //cache "window height" and "scroll top"
                setCache: function() {
                    self.scrollTop = self.window.scrollTop();
                    self.windowHeight = self.window.height();
                },
                
                // reset all instances
                reset: function() {
                    self.setCache();
                    self.enabledInstances.forEach(function(item) {
                        item.reset();
                    });
                },

                startListeners: function() {
                    self.setCache();

                    $(window).on('resize.fitscreenvertically', function(e) {
                        self.reset();
                    });

                    $(document).on('scroll.fitscreenvertically', function(e) {
                        self.reset();
                    });
                },

                stopListeners: function() {
                    $(window).off('resize.fitscreenvertically');
                    $(document).off('scroll.fitscreenvertically');
                }
            };


            /**
             * @class FitScreenVertically
             * @param {jQuery} container jQuery element that need to be responsive to height.
             * @param {Boolean} scroll Whether or not the element should automatically be scrollable
             * @constructor
             */
            function FitScreenVertically(container) {
                if (container.length) {
                    this.container = container.first();
                }
            }

            /**
             * Start watching on scroll and window resize.
             * Set height of container if visible
             * 
             * @method enable
             */
            FitScreenVertically.prototype.enable = function() {
                if ( !self.enabledInstances.length ) {
                    self.startListeners();
                }

                self.enabledInstances.push(this);
                this.reset();
            }; 

            /**
             * Stop watching on scroll and window resize.
             * Revert all actions done in enable method.
             *
             * @method disable
             */
            FitScreenVertically.prototype.disable =  function() {
                var position = self.enabledInstances.indexOf(this); 
                self.enabledInstances.splice(position, 1);
                this.clean();

                if ( !self.enabledInstances.length ) {
                    self.stopListeners();
                }
            };

            /**
             * Recalculate heiht of container if it is visible.
             * 
             * @method reset
             */
            FitScreenVertically.prototype.reset =  function() {
                if (this.container.is(':visible')) {
                    this.recalculateHeight();
                }
            };

            /**
             * Set height of container if it doesn't fits the screen.
             * Remove height if container fit the area.
             * 
             * @method reculculateHeight
             */
            FitScreenVertically.prototype.recalculateHeight =  function() {
                var outerHeight = this.container.outerHeight(),
                    innerHeight = this.container.innerHeight(),
                    realHeight = this.container[0].scrollHeight + outerHeight - innerHeight,
                    // offset top from window
                    offsetTop = this.container.offset().top - self.scrollTop,
                    newHeight = self.windowHeight - offsetTop - self.windowBottomMargin;

                // Do nothing if container cropped from top by screen
                if (offsetTop < 0) {
                    return;
                }

                newHeight = newHeight < self.minHeight ? self.minHeight : newHeight;

                if (self.windowHeight < realHeight + offsetTop) {
                    this.container.css({
                        'height': newHeight + 'px',
                        'overflow-y': 'scroll'
                    });
                } else {
                    this.clean();
                }
            };

            /**
             * Clean css added to make container scrollable within the screen
             * 
             * @method clean
             */
            FitScreenVertically.prototype.clean =  function() {
                this.container.css({
                    'height': '',
                    'overflow-y': ''
                });
            };


            return FitScreenVertically;
        })();

        return FitScreenVertically;
    }
);
